import type { IconButtonProps } from '@mui/material';
import { FilterFilledIcon, FilterIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import IconButton from './IconButton';

export interface FilterIconButtonProps extends IconButtonProps {
  isActive?: boolean;
}

const FilterIconButton = forwardRef<HTMLButtonElement, FilterIconButtonProps>(
  ({ isActive = false, ...props }, ref) => {
    return (
      <IconButton ref={ref} {...props}>
        {isActive ? (
          <FilterFilledIcon />
        ) : (
          <FilterIcon />
        )}
      </IconButton>
    );
  },
);

FilterIconButton.displayName = 'FilterIconButton';
export default FilterIconButton;
